<script setup lang="ts">
import { cva } from 'class-variance-authority';
import { useGlobal } from '@/composables';
import { cn } from '@/lib/utils';

const { language } = useGlobal();

defineOptions({
  inheritAttrs: false,
});

const urls: { [key: string]: URL } = {};
const getLogoUrl = (variant: string) => {
  const key = `logo-${variant}`;
  if (!(key in urls)) {
    urls[key] = new URL(`/src/assets/images/Misc/logo-${variant}.svg?url`, import.meta.url);
  }

  return urls[key];
};

const logoVariants = cva('inline-block select-none', {
  variants: {
    background: {
      default: '',
      'matte-glass': 'rounded-sm bg-white/60 p-4 backdrop-blur-md',
    },
  },
  defaultVariants: {
    background: 'default',
  },
});

interface Props {
  background?: NonNullable<Parameters<typeof logoVariants>[0]>['background'];
  variant?: 'mono' | 'color';
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'mono',
});
</script>

<template>
  <a
    :class="cn(logoVariants({ background }), $attrs.class ?? '')"
    :href="`https://www.lhoist.com/${language}`"
    target="_blank"
  >
    <img :src="getLogoUrl(props.variant).href" alt="Lhoist logo" width="189" height="72" />
  </a>
</template>
